var _path, _path2, _path3, _path4, _path5, _path6;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogoLong(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 174,
    height: 55,
    viewBox: "0 0 174 55",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M42 0H0V12H36C39.3137 12 42 14.6863 42 18V36C42 39.3137 39.3137 42 36 42H0V54H42C48.6274 54 54 48.6274 54 42V12C54 5.37256 48.6274 0 42 0Z",
    fill: "#18181A"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M112 0H70C63.3726 0 58 5.37256 58 12V21C58 27.6274 63.3726 33 70 33H99C101.209 33 103 34.7909 103 37C103 40.3137 100.314 42 97 42H61V54H103C109.627 54 115 48.6274 115 42V33C115 26.3726 109.627 21 103 21H74.5C72.0147 21 70 18.9853 70 16.5C70 13.1863 72.6863 12 76 12H112V0Z",
    fill: "#5E3AEE"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M164.275 25C164.275 13.9543 155.321 5 144.275 5C133.229 5 124.275 13.9543 124.275 25C124.275 36.0458 133.229 45 144.275 45C155.321 45 164.275 36.0458 164.275 25ZM144.275 0C158.082 0 169.275 11.1929 169.275 25C169.275 31.1997 167.018 36.8723 163.281 41.2411C162.362 42.316 161.353 43.312 160.266 44.2175C155.932 47.8281 150.357 50 144.275 50C130.468 50 119.275 38.8072 119.275 25C119.275 11.1929 130.468 0 144.275 0Z",
    fill: "#5E3AEE"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M144 7C146.364 7 148.704 7.46558 150.888 8.37017C153.072 9.27475 155.056 10.6006 156.728 12.2721C158.399 13.9435 159.725 15.9278 160.63 18.1117C161.534 20.2956 162 22.6362 162 25H156.119C156.119 23.4085 155.806 21.8326 155.197 20.3622C154.588 18.8918 153.695 17.5558 152.57 16.4305C151.444 15.3051 150.108 14.4124 148.638 13.8034C147.167 13.1943 145.592 12.8809 144 12.8809V7Z",
    fill: "#5E3AEE"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M167.055 40.9857L173.11 47.0414L172 50.6463L169.642 53.0038L166.038 54.1141L159.982 48.0584L162 46.0403L165.04 43L167.055 40.9857Z",
    fill: "#5E3AEE"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M160.266 44.2175L162 46.0403L165.04 43L163.281 41.2411C162.362 42.316 161.353 43.312 160.266 44.2175Z",
    fill: "#5E3AEE"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoLong);
export default __webpack_public_path__ + "static/media/logo-long.3cf2b8514f1d5d151a57c6cf1bce016a.svg";
export { ForwardRef as ReactComponent };